import React, { useRef, useState,useEffect } from "react"
import NoDeliveryBoy from "./no-delivery-boy/NoDeliveryBoy"
import ListDeliveryBoy from "./list-deliveryboy/ListDeliveryBoy"
import AddDeliveryBoy from "./add-delivery-boy/AddDeliveryBoy"
import { getDeliveryBoyList } from "../../actions/deliveryBoy"
import { connect, useSelector,useDispatch } from "react-redux"
import styles from './deliveryboy.scss'
import config from '../../../config/config'
import { pageLoad, pageLoadForIos } from "../../common/Utills";

const DeliveryBoy = (props) => {
  const dispatch = useDispatch()
  const deliveryBoysList = useSelector(
    (state) => state.deliveryBoy.deliveryBoyList
  )
  const [tab, setTab] = useState({ cur: props?.fromOrders ? "2":"", prev: "" })
  const [getListingStatus, setGetListingStatus] = useState(false)
  const [editData, setEditData] = useState();
  const [redirecturl,setRedirecturl] = useState();
  useEffect(() => {
    getDelBoyList(props.session.token)

    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    
    if(params?.redirectFrm == "onboarding")
    {
      let url = config.dcBizDomainUrl+'/seller-dashboard/accountsetting?'+Object.keys(params).map(key => key+'='+params[key]).join('&')
      setRedirecturl(url)
    }

    if(window){
      window.appHandler = (jsonStr) => {
          try {
            const transformedJson = JSON.parse(jsonStr);
            const {eventType, redirectionurl} = transformedJson;
            if(eventType == "deviceback"){
                if (JdLiteInterface && JdLiteInterface.verticalHandler) {
                    const exitJson ={"action":"exit"};
                    JdLiteInterface.verticalHandler(JSON.stringify(exitJson));
                }
                else if (window.webkit && window.webkit.messageHandlers['callbackHandler']) {
                  const logjson = JSON.stringify({ "action": "exit" });
                  window.webkit.messageHandlers.callbackHandler.postMessage(logjson);
                }
                else if(redirecturl){
                  window.location.href = redirecturl
                }
            }
          } catch (e) {
            console.log(e)
          }
      };
      if(props.isJdSourceAndroid){
        pageLoad();
      }
      if (props.isJdBusinessIOS) {
        pageLoadForIos();
      }
    }

  },[props.session.token])

  const getDelBoyList = async (docid) => {
    await getDeliveryBoyList(dispatch,docid)
    await setGetListingStatus(true)
  }

  const apkback = () => {
    if(props.isJdSourceAndroid){
      if (JdLiteInterface && JdLiteInterface.verticalHandler) {
          const exitJson ={"action":"exit"};
          JdLiteInterface.verticalHandler(JSON.stringify(exitJson));
      }
    }
    else if (props.isJdBusinessIOS) {
      if (window.webkit && window.webkit.messageHandlers['callbackHandler']) {
          const logjson = JSON.stringify({ "action": "exit" });
          window.webkit.messageHandlers.callbackHandler.postMessage(logjson);
      }
    }
    else if(redirecturl){
      window.location.href = redirecturl
    }
  }

  const showAddDeliveryBoy = (cur, prev,data) => {
    if(data)
      setEditData(data)
    else 
      setEditData(data)
    setTab({ cur, prev })
  }

  if(getListingStatus)
  {
    return (
      <>
        {tab.cur === "2" ?
          <AddDeliveryBoy {...props} showAddDeliveryBoy={showAddDeliveryBoy} tab={tab} editData={editData} />
        : (deliveryBoysList && Array.isArray(deliveryBoysList) ?
            (deliveryBoysList.length > 0 ?
              <ListDeliveryBoy showAddDeliveryBoy={showAddDeliveryBoy} tab={tab} redirecturl={redirecturl} apkback={apkback} />
              :
              <NoDeliveryBoy showAddDeliveryBoy={showAddDeliveryBoy} tab={tab} redirecturl={redirecturl} apkback={apkback} />
            )
           : <NoDeliveryBoy showAddDeliveryBoy={showAddDeliveryBoy} tab={tab} redirecturl={redirecturl} apkback={apkback} /> 
        )} 
        <div className={"pAgx overlay-staff-listing "+styles[(props.isMobile?"display-none":"display-block")]}></div>
        {!props?.fromOrders ? <div
          className={styles[props.isMobile?"bg-none":"bg-jd"]}
          style={{
            backgroundImage:
            props.isMobile?'none':'url("https://image1.jdomni.in/jdomni_email/Jdbusinessbg_2207071808.png")',
            marginLeft: "80px",
            height: "500px",
            backgroundRepeat: "no-repeat",
          }}
        ></div>:null} 
      </>
    )
    
  }
  else return null  
}

const mapStateToProps = (state, props) => {
  return {
    ...props,
    isMobile: state.library.deviceData.isMobile,
    session: state.session,
    isJdBusinessIOS: state.session.isJdBusinessIOS,
    isJdSourceAndroid: state.session.isJdSourceAndroid,
  }
}
export default connect(mapStateToProps, {})(DeliveryBoy)
